<template>
  <div class="u-mrgn--4">
    <div class="u-mrgn-bottom--2">Baca Juga:</div>
    <div v-if="otherLinks.length">
      <span v-for="(link,index) in otherLinks" :key="index">
        <a :href="link.link_url">{{ link.link_title }}</a> <span v-if="index != otherLinks.length -1">| </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherLinkFooter',
  props: {
    otherLinks: {
      type: Array,
      default: [],
    }
  }
}
</script>

